"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFormUrlEncoded = exports.toSnakeCase = exports.toCamelCase = void 0;

/**
 * Recursively transforms an object keys to camelcase.
 * 
 * @param {object} object The object you want to transform to camelcase.
 */
var toCamelCase = function toCamelCase(object) {
  if (!object) {
    return {};
  }

  if (object instanceof Array) {
    return object.map(function (value) {
      var newValue = value;

      if (typeof value === 'object') {
        newValue = toCamelCase(value);
      }

      return newValue;
    });
  }

  var newObject = {};
  Object.keys(object).forEach(function (originalKey) {
    if (originalKey in object) {
      var tempNewKey = originalKey.replace(/(_\w)/g, function (match) {
        return match[1].toUpperCase();
      });
      var newKey = "".concat(tempNewKey[0].toLowerCase()).concat(tempNewKey.substring(1));
      var value = object[originalKey];

      if (value instanceof Array || value instanceof Object && !(value instanceof Date)) {
        value = toCamelCase(value);
      }

      newObject[newKey] = value;
    }
  });
  return newObject;
};
/**
 * Recursively transforms an object keys to snakecase.
 * 
 * @param {object} object The object you want to transform to snakecase.
 */


exports.toCamelCase = toCamelCase;

var toSnakeCase = function toSnakeCase(object) {
  if (!object) {
    return {};
  }

  if (object instanceof Array) {
    return object.map(function (value) {
      var newValue = value;

      if (typeof value === 'object') {
        newValue = toSnakeCase(value);
      }

      return newValue;
    });
  }

  var newObject = {};
  Object.keys(object).forEach(function (originalKey) {
    if (originalKey in object) {
      var newKey = originalKey.replace(/[A-Z]/g, function (match) {
        return "_".concat(match.toLowerCase());
      });
      var value = object[originalKey];

      if (value instanceof Array || value instanceof Object && !(value instanceof Date)) {
        value = toSnakeCase(value);
      }

      newObject[newKey] = value;
    }
  });
  return newObject;
};
/**
 * Transforms and object to a form encoded url string.
 * 
 * @param {object} object The object you want to transform to an encoded url string.
 */


exports.toSnakeCase = toSnakeCase;

var toFormUrlEncoded = function toFormUrlEncoded(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key]));
  }).join('&');
};

exports.toFormUrlEncoded = toFormUrlEncoded;